class CourseApplicationFormAttendeesAndPrices extends BasePopup {

    constructor(el) {
        super(el);
        this.form = /** @type HTMLFormElement */ document.querySelector('#courseApplicationForm');
        if (!this.form) {
            this.$el.remove();
            return;
        }
        this.props = JSON.parse(this.$el.dataset.props);
        this.formPlaceholder = this.form.querySelector('[data-attendees-and-prices]');
        this.container = /** @type HTMLDivElement */ this.$el;
        this.attendeeContainer = /** @type HTMLDivElement */ this.$el.querySelector('[data-attendee-container]');
        this.attendeeStub = /** @type HTMLDivElement */ this.$el.querySelector('[data-attendee]');
        this.addAttendeeButton = this.$el.querySelector('[data-attendee-button-add]');
        this.attendees = /** @type Array<HTMLDivElement> */ [];
        this.pricingContainer = this.$el.querySelector('[data-pricing]');
        this.totalPriceElement = this.pricingContainer.querySelector('[data-pricing-total-price]');
        this.totalPriceVatElement = this.pricingContainer.querySelector('[data-pricing-total-pricevat]');

        this.formPlaceholder.parentNode.parentNode.insertBefore(this.container, this.formPlaceholder.parentNode);
        if (!this.props.price) {
            this.pricingContainer.remove();
        }
        this.constructAttendeeContainers();
        this.recountPrices();
        this.bindAddButton();
        this.updateUI();
    }

    constructAttendeeContainers() {
        this.form.querySelectorAll('[data-group-id]').forEach(groupElement => {
            const id = groupElement.dataset.groupId;
            let filled = false;
            groupElement.querySelectorAll('input[name^="firstName"],input[name^="lastName"]').forEach(/** @type HTMLInputElement */input => {
                if (input.value) {
                    filled = true;
                }
            });
            const attendee = this.createAttendee(groupElement.children, filled || id === '0');
            this.attendeeContainer.append(attendee);
            this.attendees.push(attendee);
        })
    }

    createAttendee(/** @type HTMLCollection */ items, visible) {
        const attendeeContainer = /** @type HTMLDivElement */ this.attendeeStub.cloneNode(true);
        attendeeContainer.removeAttribute('data-stub');
        if (visible) {
            attendeeContainer.classList.add('visible');
        }
        const content = /** @type HTMLDivElement */ attendeeContainer.querySelector('[data-attendee-content]');
        Array.from(items).forEach(item => {
            content.append(item);
        });
        this.bindRemoveButton(attendeeContainer);
        return attendeeContainer;
    }

    bindRemoveButton(attendeeContainer) {
        const removeButton = attendeeContainer.querySelector('[data-attendee-button-remove]');
        removeButton.addEventListener('click', () => {
            attendeeContainer.classList.remove('visible');
            attendeeContainer.querySelectorAll('input[type="text"]').forEach(input => {input.value = '';});
            attendeeContainer.querySelectorAll('select').forEach(select => {select.selectedIndex = 0;});
            this.recountPrices();
            this.updateUI();
        });
    }

    bindAddButton() {
        this.addAttendeeButton.addEventListener('click', () => {
            const firstHidden = this.attendees.find(attendeeContainer => !attendeeContainer.classList.contains('visible'));
            firstHidden.classList.add('visible');

            // reorder
            const lastVisible = this.attendees.findLast(attendeeContainer => attendeeContainer.classList.contains('visible'));
            lastVisible.after(firstHidden);
            this.attendees = [];
            this.attendeeContainer.querySelectorAll('[data-attendee]').forEach(attendee => {
                this.attendees.push(attendee);
            })

            this.recountPrices();
            this.updateUI();
        })
    }

    recountPrices() {
        if (!this.props?.price) {
            return;
        }
        const attendeeCount = this.attendees.filter(attendeeContainer => attendeeContainer.classList.contains('visible')).length;
        const totalPrice = Math.round(attendeeCount * this.props.price);
        this.totalPriceElement.textContent = totalPrice.toLocaleString();
        const totalPriceVat = Math.round(attendeeCount * this.props.priceVat);
        this.totalPriceVatElement.textContent = totalPriceVat.toLocaleString();
    }

    updateUI() {
        const visibleAttendees = this.attendees.filter(attendeeContainer => attendeeContainer.classList.contains('visible')).length;
        const removeButtonsShouldBeVisible = visibleAttendees > 1;
        const addButtonShouldBeVisible = this.attendees.filter(attendeeContainer => !attendeeContainer.classList.contains('visible')).length > 0 && this.props.remainingAttendeeCount > visibleAttendees;
        this.attendees.forEach(attendeeContainer => {
            attendeeContainer.querySelector('[data-attendee-button-remove]').classList.toggle('hidden', !removeButtonsShouldBeVisible);
        })
        this.addAttendeeButton.classList.toggle('hidden', !addButtonShouldBeVisible);
        let i = 1;
        this.attendees.filter(attendeeContainer => attendeeContainer.classList.contains('visible')).forEach(attendeeContainer => {
            attendeeContainer.querySelector('[data-attendee-title-number]').textContent = String(i++);
        })
    }
}
